import classnames from 'classnames';
import React from 'react';
import { useLayoutState } from '../../layout/Context';
import Link from '../Link';
import Typography from '../Typography';

const ToolBar = () => {
  const { locale } = useLayoutState();

  return (
    <div className="container-xl flex justify-end py-2">
      <div className="flex gap-x-4">
        <Link to="/" className={
          classnames({
            'no-underline hover:underline': locale !== 'uk',
          })}
        >
          <Typography variant="small" as="span">
            Укр
          </Typography>
        </Link>
        <Link to="/en/" className={
          classnames({
            'no-underline hover:underline': locale !== 'en',
          })}
        >
          <Typography variant="small" as="span">
            En
          </Typography>
        </Link>
      </div>
    </div>
  );
};

export default ToolBar;
